export function clamp(value: number, min: number, max: number) {
  "worklet";
  return Math.max(min, Math.min(value, max));
}
